import { collection, query, getDocs, onSnapshot, Timestamp, addDoc } from 'firebase/firestore';
import { auth, db } from '@/services/firebase/firebase';
import type { Payment } from '@/types/firebase/payments';

// Re-export types for convenience
export type { Payment } from '@/types/firebase/payments';

const colRef = () => collection(db, 'payments', auth.currentUser!.uid, 'items');

const isVisiblePayment = (payment: Payment) =>
  payment.excludedFromAdminMetrics !== true;

// Legacy held payments predate immediate recognition. Present them as succeeded
// to lawyers without mutating the historical Firestore record.
const normalizePayment = (payment: Payment): Payment =>
  payment.status === 'held' ? { ...payment, status: 'succeeded' } : payment;

export const listPayments = async (): Promise<Payment[]> => {
  const snap = await getDocs(query(colRef()));
  return snap.docs
    .map((d)=> ({ id: d.id, ...(d.data() as Omit<Payment,'id'>) }))
    .filter(isVisiblePayment)
    .map(normalizePayment);
};

export const onPaymentsSnapshot = (cb: (items: Payment[]) => void) => {
  return onSnapshot(query(colRef()), (snap)=>{
    const items = snap.docs
      .map((d)=> ({ id: d.id, ...(d.data() as Omit<Payment,'id'>) }))
      .filter(isVisiblePayment)
      .map(normalizePayment);
    cb(items);
  });
};

// helper to add payment (dev only)
export const addPayment = async (data: Omit<Payment,'id'|'createdAt'>) => {
  await addDoc(colRef(), { ...data, createdAt: Timestamp.now()});
};
